var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import InputField from "../common/InputField";
import RoleSelect from "../common/RoleSelect";
var AgentReview = /** @class */ (function (_super) {
    __extends(AgentReview, _super);
    function AgentReview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submit = function () {
            _this.props.send(WebSocketMessage("users", "invite", _this.props.user));
            _this.props.history.push("/users");
        };
        return _this;
    }
    AgentReview.prototype.render = function () {
        var _this = this;
        var _a = this.props, onCancel = _a.onCancel, user = _a.user;
        return (React.createElement("div", { className: "container content" },
            React.createElement("h5", null, "Please confirm your entries"),
            React.createElement("br", null),
            React.createElement("div", null,
                React.createElement("div", { className: "card-panel" },
                    React.createElement(InputField, { label: "Email", type: "text", placeholder: "", readonly: true, value: user.email }),
                    React.createElement(InputField, { label: "First name", type: "text", placeholder: "", readonly: true, value: user.firstName }),
                    React.createElement(InputField, { label: "Last name", type: "text", placeholder: "", value: user.lastName, readonly: true }),
                    React.createElement(InputField, { label: "Company", type: "text", placeholder: "", value: user.company, readonly: true }),
                    user.enterprises.map(function (enterprise, index) {
                        var _a, _b;
                        return (React.createElement(InputField, { key: index, label: "Enterprise", type: "text", placeholder: "", value: (_b = (_a = _this.props.enterprises.find(function (e) { return e.id === enterprise; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "", readonly: true }));
                    })),
                React.createElement("div", { className: "card-panel" },
                    React.createElement(InputField, { label: "Address", type: "text", placeholder: "", value: user.address, readonly: true }),
                    React.createElement(InputField, { label: "City", type: "text", placeholder: "", value: user.city, readonly: true }),
                    user.country === "DE" && (React.createElement(InputField, { label: "Postal code", type: "text", placeholder: "", value: user.postalCode, readonly: true })),
                    React.createElement(CountrySelect, { disabled: true, value: user.country, enterprises: this.props.enterprises }),
                    React.createElement(RoleSelect, { disabled: true, value: user.role })),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("button", { className: "white darken-3 btn-flat btn red-text", onClick: onCancel }, "Back"),
                React.createElement("button", { className: "green right btn-flat white-text", onClick: function () { return _this.submit(); } }, "Add Agent/Admin"))));
    };
    return AgentReview;
}(Component));
export default withRouter(AgentReview);



//////////////////
// WEBPACK FOOTER
// ./src/components/users/AgentReview.tsx
// module id = 1232
// module chunks = 0